import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap, tap } from 'rxjs/operators';
import { interval, of } from 'rxjs';
import { getUnits, updateUnitName } from '../actions/units.actions';
import * as UnitSharedActions from '../actions/units-shared.actions';
import { UnitsService } from '../../../units/services/units.service';
import { getUnitsFailure, getUnitsSuccess, updateUnitNameFailure, updateUnitNameSuccess } from '../actions/units-api.actions';
import { getPositions } from '../actions/positions.actions';
import { cacheLifeTime } from '../../../shared/config';
import { LoadingBarState } from '@ngx-loading-bar/core/loading-bar.state';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable()
export class UnitsEffects {

  getUnits$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUnits.type, UnitSharedActions.getData.type),
      switchMap(action =>
        this._unitsService.getUnits()
          .pipe(
            exhaustMap(units => of(getUnitsSuccess({units: units}))),
            catchError(error => of(getUnitsFailure({error})))
          )
      )
    )
  );

  updateUnitName$ = createEffect(() =>
    this._actions$.pipe(
      ofType(updateUnitName.type),
      tap(() => this._loader.start()),
      switchMap((action: any) => this._unitsService.updateUnitName(action.unitId, action.name).pipe(
        exhaustMap((data) => of(updateUnitNameSuccess({data: data}))),
        catchError(error => of(updateUnitNameFailure({error}))),
        tap(() => this._loader.complete()),
      ))
    )
  );

  getUnitsSuccess$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUnitsSuccess.type),
      switchMap((action: any) => of(getPositions({unitIds: action.units.map(x => x['unitId'])})))
    )
  );


  @Effect()
  clear$ = interval(cacheLifeTime).pipe(
    switchMap((action) => of(UnitSharedActions.clearData()))
  );

  @Effect()
  getData$ = this._actions$.pipe(
    ofType(UnitSharedActions.clearData.type),
    switchMap((action) => of(UnitSharedActions.getData()))
  );

  private _loader: LoadingBarState;

  constructor(
    private _actions$: Actions,
    private _unitsService: UnitsService,
    private _loadingBar: LoadingBarService
  ) {
    this._loader = this._loadingBar.useRef('main');
  }
}
